import NextHead from 'next/head'
import Script from 'next/script'
import config from '../../../config.json'

export default function Head({
    title
    // description,
    // og_title,
    // og_description,
    // og_url,
    // og_type = 'website',
    // favicon
}) {
    return (
        <>
            <NextHead>
                <title>{title}</title>
                {/* meta tags */}
                {/* <meta
                    name="description"
                    content={description || config?.texts?.seo?.description}
                    key="description"
                />
                <meta property="og:title" content={og_title || config?.texts?.seo?.og_title} key="og-title" />
                <meta
                    property="og:description"
                    content={og_description || config?.texts?.seo?.og_description}
                    key="og-description"
                />
                <meta property="og:url" content={og_url} key="og-url" />
                <meta property="og:type" content={og_type} key="og-type" /> */}
                {/* favicon */}
                <link rel="icon" href="/img/favicon/favicon-32x32.png" />
            </NextHead>
            {/* scripts */}
            {config.integrations?.umami && (
                <Script
                    async
                    defer
                    data-website-id={config.integrations.umami.websiteId}
                    src="https://analytics.jeldnews.com/umami.js"
                ></Script>
            )}
            {config.integrations?.tawk && (
                <>
                    <Script
                        id="tawk_pre"
                        dangerouslySetInnerHTML={{
                            __html: 'var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();'
                        }}
                    ></Script>
                    <Script
                        id="tawk"
                        async
                        charset="UTF-8"
                        crossorigin="*"
                        src={`https://embed.tawk.to/${config.integrations.tawk.id}`}
                    ></Script>
                </>
            )}
            {config.integrations?.enjaneb && (
                <Script
                    async
                    id={config.integrations.enjaneb.id}
                    enjaneb_protection_ID={config.integrations.enjaneb.token}
                    src="https://www.enjaneb.com/sciipt/accenj.js"
                ></Script>
            )}
        </>
    )
}
